import { usePostHog } from "posthog-js/react"
import { GetCurrentUserResult } from "app/users/queries/getCurrentUser"

type EventProperties = {
  [key: string]: string | number | boolean | null | undefined
}

type AnalyticsEvent = {
  name: string
  properties?: EventProperties
}

export function usePosthogWithCurrentUser(currentUser: GetCurrentUserResult) {
  const posthog = usePostHog()

  const capture = (event: AnalyticsEvent) => {
    // Only track if user is not an admin and has an organization
    if (
      !currentUser ||
      currentUser.role === "ADMIN" ||
      currentUser.role === "KID"
    )
      return

    if (
      currentUser.organizationUsers &&
      currentUser.organizationUsers.length > 0 &&
      currentUser.organizationUsers[0]?.organization
    ) {
      const organizationUser = currentUser.organizationUsers[0]
      const { organization } = organizationUser
      const baseProperties = {
        role: currentUser.role,
        organizationRole: organizationUser.role,
        subscriptionType: organization.subscription.subscriptionType,
        trialAccount: organization.trialAccount,
        userPropOrganizationId: organization.id,
      }

      // Merge base properties with any custom properties
      posthog.capture(event.name, {
        ...event.properties,
        ...baseProperties,
      })
    }
  }

  return { capture }
}
